import { useState } from 'react'

import { If } from '@itau-loans-www/components'

import FinalLoader from './components/FinalLoader'
import Form from './components/Form'

const BankData = ({
  hasWppBtn,
  hasSecurityTag = false,
  isCaseOfTest = false
}) => {
  const [isFinalLoading, setIsFinalLoading] = useState(false)

  return (
    <If
      condition={isCaseOfTest}
      renderIf={
        <If
          condition={isFinalLoading}
          renderIf={<FinalLoader />}
          renderElse={
            <Form
              hasWppBtn={hasWppBtn}
              isCaseOfTest={isCaseOfTest}
              hasSecurityTag={hasSecurityTag}
              setIsFinalLoading={setIsFinalLoading}
            />
          }
        />
      }
      renderElse={
        <Form
          hasWppBtn={hasWppBtn}
          isCaseOfTest={isCaseOfTest}
          hasSecurityTag={hasSecurityTag}
          setIsFinalLoading={setIsFinalLoading}
        />
      }
    />
  )
}

export default BankData
